import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import {
  validaSoloNumero,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  validaNumeroTelefono,
  validaEmail,
} from "../../util/varios";
import moment from "moment";
import axios from "axios";
import { Dimmer } from "../spinner";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import CatalogoAgente from "../../catalogos/catalogoAgente";
import { Mensaje, MensajeSiNo } from "../mensajes";

const ModalActUsuarioRentas = (props) => {
  const [clase, setClase] = useState("d-flex bluex-bg");
  const chkFvCon = useRef();
  const chkFvInc = useRef();
  const chkFvMod = useRef();
  const chkFvEli = useRef();
  const chkFvTodo = useRef();
  const chkInmCon = useRef();
  const chkInmInc = useRef();
  const chkInmMod = useRef();
  const chkInmEli = useRef();
  const chkEntCon = useRef();
  const chkEntInc = useRef();
  const chkEntMod = useRef();
  const chkEntEli = useRef();
  const chkInmTodo = useRef();
  const chkEntTodo = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnEnviar = useRef();
  const chkRentCon = useRef();
  const chkRentInc = useRef();
  const chkRentMod = useRef();
  const chkRentEli = useRef();
  const chkRentTodo = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [body, setBody] = useState({});
  const [mostrar4, setMostrar4] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [contar, setContar] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [password, setPassword] = useState("");
  const [activate, setActivate] = useState(false);
  const [usuario, setUsuario] = useState();
  const [persona, setPersona] = useState({
    cedula: "",
    nombres: "",
    apellidos: "",
    direccion: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    fnacimiento: "",
    nacionalidad: "",
    sexo: "",
  });
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [correo, setCorreo] = useState("");
  const [visibleCheck, setVisibleCheck] = useState({
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
  });
  const [reportes, setReportes] = useState({
    pdf1: "",
    pdf2: "",
    pdf3: "",
    pdf4: "",
    pdf5: "",
    pdf6: "",
    pdf7: "",
    pdf8: "",
    pdf9: "",
  });
  const [modulos, setModulos] = useState({
    modulo1: "",
    modulo2: "",
    modulo3: "",
    modulo4: "",
    modulo5: "",
    modulo6: "",
    modulo7: "",
    modulo8: "",
    modulo9: "",
  });

  const [modulosConfig, setModulosConfig] = useState({
    moduloconfig1: "",
    moduloconfig2: "",
    moduloconfig3: "",
  });

  const [localStore, setLocalStore] = useState({
    accconfigrentas: "",
    accrentasinm: "",
    accpdfrentas: "",
    accopinm: "",
    accoprentas: "",
  });

  const [opExpendio, setOpExpendio] = useState({
    opcione1: "",
    opcione2: "",
    opcione3: "",
    opcione4: "",
  });
  const [fechaVen, setFechaVen] = useState({
    opcione1: "",
    opcione2: "",
    opcione3: "",
    opcione4: "",
  });
  const [opEntes, setOpEntes] = useState({
    opcione1: "",
    opcione2: "",
    opcione3: "",
    opcione4: "",
  });
  const [permisos, setPermisos] = useState({
    acccontribuyente: "0000",
    accactividad: "0000",
    accdeclaraciones: "000",
    accacticontri: "00",
    accagente: "0000",
    accusuariocome: "0000",
  });

  const [url, setUrl] = useState("");

  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let idusuario = JSON.parse(localStorage.getItem("idusuario"));

  const [deshabilitado, setDeshabilitado] = useState(false);

  const [itemAccimpminas, setItemAccimpminas] = useState();
  const [itemAccregminas, setItemAccregminas] = useState();
  const [itemAccclaseminas, setItemAccclaseminas] = useState();
  const [itemAccconfigminas, setItemAccconfigminas] = useState();
  const [itemAccpdfminas, setItemAccpdfminas] = useState();
  const [itemAccfvminas, setItemAccfvminas] = useState();
  const [acciones, setAcciones] = useState({
    inm1: "0",
    inm2: "0",
    inm3: "0",
    inm4: "0",
    rent1: "0",
    rent2: "0",
    rent3: "0",
    rent4: "0",
  });
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndex1, setTabIndex1] = useState(0);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const txtIdUsuario = useRef();
  const txtLogin = useRef();
  const txtPassword = useRef();
  const txtConfirmPassword = useRef();
  const txtIdAgente = useRef();
  const txtNombreAgente = useRef();
  const txtCedula = useRef();
  const txtNombreUsuario = useRef();
  const txtApellidoUsuario = useRef();
  const txtDireccionUsuario = useRef();
  const txtEmailUsuario = useRef();
  const txtTlfUsuario = useRef();
  const txtCelUsuario = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const cmbStatus = useRef();

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (props.operacion) {
      setOperacion(props.operacion);
    }

    if (op.reportes != null) {
      setUrl(op.reportes.trim());
    } else {
      setUrl("");
    }
  }, [props.operacion]);

  const procesarRegistro = () => {
    let endpoint = `${op.conexion}/api/comun/actualizarusuariotimbre/${operacion}`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          props.onHideRender();
          blanquear();
          setActivate(false);

          var mensaje = "";
          if (operacion === 1) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido registrada de manera satisfactoria.";
          } else if (operacion === 2) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido modificada de manera satisfactoria.";
          } else if (operacion === 3) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido eliminada de manera satisfactoria.";
          }

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: mensaje,
            icono: "exito",
          });

          if (idusuario === parseInt(props.usuario.idusuario)) {
            if (idusuario === parseInt(props.usuario.idusuario)) {
              localStorage.setItem(
                "accconfigrentas",
                JSON.stringify(localStore.accconfigrentas)
              );
              localStorage.setItem(
                "accrentasinm",
                JSON.stringify(localStore.accrentasinm)
              );
              localStorage.setItem(
                "accpdfrentas",
                JSON.stringify(localStore.accpdfrentas)
              );
              localStorage.setItem(
                "accopinm",
                JSON.stringify(localStore.accopinm)
              );
              localStorage.setItem(
                "accoprentas",
                JSON.stringify(localStore.accoprentas)
              );
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.ingresa === 0) {
            txtNombreUsuario.current.value = "";
            txtApellidoUsuario.current.value = "";
            txtDireccionUsuario.current.value = "";
            txtEmailUsuario.current.value = "";
            txtTlfUsuario.current.value = "";
            txtCelUsuario.current.value = "";
            txtFechaNac.current.value = "";
            cmbNacionalidad.current.value = "V";
            cmbSexo.current.value = "M";
          }

          setHabilitadoNU(true);

          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreUsuario.current.value = response.data.nombres;
            txtApellidoUsuario.current.value = response.data.apellidos;
            txtDireccionUsuario.current.value = response.data.direccion;
            txtEmailUsuario.current.value = response.data.correoe;
            txtTlfUsuario.current.value = response.data.tlf1;
            txtCelUsuario.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              setTabIndex(1);
              setTabIndex1(0);
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreUsuario.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeTodo = (e) => {
    if (e.target.name === "todoinm") {
      if (chkInmTodo.current.checked) {
        chkInmCon.current.checked = true;
        chkInmInc.current.checked = true;
        chkInmMod.current.checked = true;
        chkInmEli.current.checked = true;
      } else {
        chkInmCon.current.checked = false;
        chkInmInc.current.checked = false;
        chkInmMod.current.checked = false;
        chkInmEli.current.checked = false;
      }
    } else if (e.target.name === "todorentas") {
      if (chkRentTodo.current.checked) {
        chkRentCon.current.checked = true;
        chkRentInc.current.checked = true;
        chkRentMod.current.checked = true;
        chkRentEli.current.checked = true;
      } else {
        chkRentCon.current.checked = false;
        chkRentInc.current.checked = false;
        chkRentMod.current.checked = false;
        chkRentEli.current.checked = false;
      }
    }
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleCloseCatalogoAge = () => {
    setMostrar4(false);
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombreUsuario.current.value = nomPer;
    txtApellidoUsuario.current.value = apePer;
    txtDireccionUsuario.current.value = direPer;
    txtEmailUsuario.current.value = correoPer;
    txtTlfUsuario.current.value = tlf1Per;
    txtCelUsuario.current.value = tlf2Per;
    txtFechaNac.current.value = moment(fnacPer).format("YYYY-MM-DD");
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    btnAcepta.current.focus();
  };

  const handleAceptaCatalogoAge = (idAge, nomAge) => {
    setMostrar4(false);
    txtIdAgente.current.value = idAge;
    txtNombreAgente.current.value = nomAge;
    txtCedula.current.focus();
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };

  const catalogoAge = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar4(true);
    }
  };

  const blanquear = () => {
    setLocalStore({
      accconfigrentas: "",
      accrentasinm: "",
      accpdfrentas: "",
      accopinm: "",
      accoprentas: "",
    });
    setPassword("");
    setActivate(false);
    setCorreo("");
    setOperacionPer(0);
    setModulos({
      modulo1: "",
      modulo2: "",
      modulo3: "",
      modulo4: "",
      modulo5: "",
      modulo6: "",
      modulo7: "",
      modulo8: "",
      modulo9: "",
    });
    setReportes({
      pdf1: "",
      pdf2: "",
      pdf3: "",
      pdf4: "",
      pdf5: "",
      pdf6: "",
      pdf7: "",
      pdf8: "",
      pdf9: "",
    });
    setOpExpendio({
      opcione1: "",
      opcione2: "",
      opcione3: "",
      opcione4: "",
    });
    setOpEntes({
      opcione1: "",
      opcione2: "",
      opcione3: "",
      opcione4: "",
    });
    setAcciones({
      inm1: " ",
      inm2: "",
      inm3: "",
      inm4: "",
      rent1: "",
      rent2: "",
      rent3: "",
      rent4: "",
    });
    setVisibleCheck({
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
    });
    setPermisos({
      acccontribuyente: "0000",
      accactividad: "0000",
      accdeclaraciones: "000",
      accacticontri: "00",
      accagente: "0000",
      accusuariocome: "0000",
    });
    setModulosConfig({
      moduloconfig1: "",
      moduloconfig2: "",
      moduloconfig3: "",
    });
    setFechaVen({
      opcione1: "",
      opcione2: "",
      opcione3: "",
      opcione4: "",
    });
    setItemAccimpminas("");
    setItemAccregminas("");
    setItemAccclaseminas("");
    setItemAccconfigminas("");
    setItemAccpdfminas("");
    setItemAccfvminas("");
  };

  const onChange = (e) => {
    if (e.target.id === "modulo") {
      setModulos({ ...modulos, [e.target.name]: e.target.value });

      if (e.target.name === "modulo1") {
        if (e.target.value === "1") {
          setVisibleCheck({ ...visibleCheck, checked1: true });
        } else {
          setVisibleCheck({ ...visibleCheck, checked1: false });
          chkInmCon.current.checked = false;
          chkInmInc.current.checked = false;
          chkInmMod.current.checked = false;
          chkInmEli.current.checked = false;
        }
      } else if (e.target.name === "modulo2") {
        if (e.target.value === "1") {
          setVisibleCheck({ ...visibleCheck, checked2: true });
        } else {
          setVisibleCheck({ ...visibleCheck, checked2: false });
          chkEntCon.current.checked = false;
          chkEntInc.current.checked = false;
          chkEntMod.current.checked = false;
          chkEntEli.current.checked = false;
        }
      }
    } else if (e.target.id === "modulosConfig") {
      setModulosConfig({ ...modulosConfig, [e.target.name]: e.target.value });
    } else if (e.target.id === "reportes") {
      setReportes({ ...reportes, [e.target.name]: e.target.value });
    }
  };

  const cancelar = () => {
    blanquear();

    props.onHideCancela();
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputCodigo") {
        txtLogin.current.focus();
      } else if (event.target.id === "inputLogin") {
        txtPassword.current.focus();
      } else if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtPassword.current.focus();
        } else {
          txtConfirmPassword.current.focus();
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtConfirmPassword.current.focus();
        } else {
          txtIdAgente.current.focus();
        }
      } else if (event.target.id === "inputNomUsuario") {
        txtApellidoUsuario.current.focus();
      } else if (event.target.id === "inputApeUsuario") {
        txtDireccionUsuario.current.focus();
      } else if (event.target.id === "inputDireUsuario") {
        txtEmailUsuario.current.focus();
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const validarAgente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosAgente(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const datosAgente = (idagente) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idagente}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtNombreAgente.current.value = response.data.nombre;
            txtCedula.current.focus();
            setContar(contar + 1);
          } else {
            txtNombreAgente.current.value = "";
            txtIdAgente.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Agente no existe.",
              icono: "informacion",
            });
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  const check = (e) => {
    if (
      chkInmCon.current.checked === true &&
      chkInmInc.current.checked === true &&
      chkInmMod.current.checked === true &&
      chkInmEli.current.checked === true
    ) {
      chkInmTodo.current.checked = true;
    } else {
      chkInmTodo.current.checked = false;
    }

    if (
      chkRentCon.current.checked === true &&
      chkRentInc.current.checked === true &&
      chkRentMod.current.checked === true &&
      chkRentEli.current.checked === true
    ) {
      chkRentTodo.current.checked = true;
    } else {
      chkRentTodo.current.checked = false;
    }
  };

  const check2 = (e) => {
    if (
      chkEntCon.current.checked === true &&
      chkEntInc.current.checked === true &&
      chkEntMod.current.checked === true &&
      chkEntEli.current.checked === true
    ) {
      chkEntTodo.current.checked = true;
    } else {
      chkEntTodo.current.checked = false;
    }
  };
  const check3 = (e) => {
    if (
      chkFvCon.current.checked === true &&
      chkFvInc.current.checked === true &&
      chkFvMod.current.checked === true &&
      chkFvEli.current.checked === true
    ) {
      chkFvTodo.current.checked = true;
    } else {
      chkFvTodo.current.checked = false;
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    let inmueble = "";
    let rentas = "";
    let fecha = "";
    if (modulos.modulo1 === "1") {
      let expendio1 = chkInmCon.current.checked ? "1" : "0";
      let expendio2 = chkInmInc.current.checked ? "1" : "0";
      let expendio3 = chkInmMod.current.checked ? "1" : "0";
      let expendio4 = chkInmEli.current.checked ? "1" : "0";

      inmueble = expendio1 + expendio2 + expendio3 + expendio4;
    } else {
      inmueble = "0000";
    }

    if (modulos.modulo2 === "1") {
      let rent1 = chkRentCon.current.checked ? "1" : "0";
      let rent2 = chkRentInc.current.checked ? "1" : "0";
      let rent3 = chkRentMod.current.checked ? "1" : "0";
      let rent4 = chkRentEli.current.checked ? "1" : "0";

      rentas = rent1 + rent2 + rent3 + rent4;
    } else {
      rentas = "0000";
    }

    var sigue = true;
    var mensaje = "";
    if (txtLogin.current.value.trim() === "") {
      mensaje = "El Usuario no debe estar vacio";
      sigue = false;
      setTabIndex(0);
      txtLogin.current.focus();
    } else if (txtPassword.current.value.trim() === "" && operacion === 1) {
      mensaje = "La Contraseña no debe estar vacia";
      sigue = false;
      setTabIndex(0);
      txtPassword.current.focus();
    } else if (
      txtConfirmPassword.current.value.trim() === "" &&
      operacion === 1
    ) {
      mensaje = "La Confirmación de la Contraseña no debe estar vacia";
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (
      txtPassword.current.value.trim() !==
        txtConfirmPassword.current.value.trim() &&
      operacion === 1
    ) {
      mensaje = "Las Contraseñas no coinciden";
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      mensaje = "La cedula no debe estar vacia";
      sigue = false;
      txtCedula.current.focus();
    } else if (txtNombreUsuario.current.value.trim() === "") {
      mensaje = "Los nombres no deben estar vacios";
      sigue = false;
      txtNombreUsuario.current.focus();
    } else if (txtApellidoUsuario.current.value.trim() === "") {
      mensaje = "Los Apellidos no deben estar vacio";
      sigue = false;
      txtApellidoUsuario.current.focus();
    } else if (txtDireccionUsuario.current.value.trim() === "") {
      mensaje = "La direccion del Usuario no debe estar vacia";
      sigue = false;
      txtDireccionUsuario.current.focus();
    } else if (txtFechaNac.current.value.trim() === "") {
      mensaje = "La fecha de nacimiento no debe estar vacia";
      sigue = false;
      txtFechaNac.current.focus();
    } else if (
      modulos.modulo1 === "1" &&
      chkInmCon.current.checked === false &&
      chkInmInc.current.checked === false &&
      chkInmMod.current.checked === false &&
      chkInmEli.current.checked === false
    ) {
      mensaje =
        "Debe Seleccionar las Operaciones para el Modulo Registro de Inmueble";
      sigue = false;
      chkInmCon.current.focus();
    } else if (
      modulos.modulo2 === "1" &&
      chkRentCon.current.checked === false &&
      chkRentInc.current.checked === false &&
      chkRentMod.current.checked === false &&
      chkRentEli.current.checked === false
    ) {
      mensaje =
        "Debe Seleccionar las Operaciones para el Modulo Registro de rentas inmobiliarias";
      sigue = false;
      chkRentCon.current.focus();
    }

    if (sigue) {
      var user = [];
      var datoPer = [];
      user.push({
        idusuario:
          txtIdUsuario.current.value === "" ? "0" : txtIdUsuario.current.value,
        login: txtLogin.current.value,
        passwd: txtPassword.current.value,
        persona: txtCedula.current.value,
        status: cmbStatus.current.value,
        idagente: txtIdAgente.current.value,
        accconfigrentas: modulosConfig.moduloconfig1,
        accrentasinm: modulos.modulo1 + modulos.modulo2 + modulos.modulo3,
        accpdfrentas: reportes.pdf1,
        accopinm: inmueble,
        accoprentas: rentas,
      });

      setLocalStore({
        accconfigrentas: modulosConfig.moduloconfig1,
        accrentasinm: modulos.modulo1 + modulos.modulo2 + modulos.modulo3,
        accpdfrentas: reportes.pdf1,
        accopinm: inmueble,
        accoprentas: rentas,
      });
      datoPer.push({
        apellidos: txtApellidoUsuario.current.value.trim(),
        cedula: txtCedula.current.value,
        correoe: txtEmailUsuario.current.value,
        direccion: txtDireccionUsuario.current.value.trim(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreUsuario.current.value.trim(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfUsuario.current.value,
        tlf2: txtCelUsuario.current.value,
      });
      setUsuario(user);
      setPersona(datoPer);
      setContar2(0);
      let body = {
        operacionper: operacionPer,
        usu: JSON.stringify(user),
        perso: JSON.stringify(datoPer),
      };
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
      setBody(body);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: mensaje,
        icono: "informacion",
      });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideAcepta();
  };

  const mostrarPassword = () => setMostrarClave(!mostrarClave);
  const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setDeshabilitado(props.deshabilitado);

        if (props.operacion !== 1) {
          setModulos({
            modulo1:
              props.usuario.accrentasinm.toString().substring(0, 1) !== ""
                ? props.usuario.accrentasinm.toString().substring(0, 1)
                : "0",
            modulo2:
              props.usuario.accrentasinm.toString().substring(1, 2) !== ""
                ? props.usuario.accrentasinm.toString().substring(1, 2)
                : "0",
            modulo3:
              props.usuario.accrentasinm.toString().substring(2, 3) !== ""
                ? props.usuario.accrentasinm.toString().substring(2, 3)
                : "0",
          });

          setAcciones({
            inm1:
              props.usuario.accopinm.toString().substring(0, 1) !== ""
                ? props.usuario.accopinm.toString().substring(0, 1)
                : "0",
            inm2:
              props.usuario.accopinm.toString().substring(1, 2) !== ""
                ? props.usuario.accopinm.toString().substring(1, 2)
                : "0",
            inm3:
              props.usuario.accopinm.toString().substring(2, 3) !== ""
                ? props.usuario.accopinm.toString().substring(2, 3)
                : "0",
            inm4:
              props.usuario.accopinm.toString().substring(3, 4) !== ""
                ? props.usuario.accopinm.toString().substring(3, 4)
                : "0",
            rent1:
              props.usuario.accoprentas.toString().substring(0, 1) !== ""
                ? props.usuario.accoprentas.toString().substring(0, 1)
                : "0",
            rent2:
              props.usuario.accoprentas.toString().substring(1, 2) !== ""
                ? props.usuario.accoprentas.toString().substring(1, 2)
                : "0",
            rent3:
              props.usuario.accoprentas.toString().substring(2, 3) !== ""
                ? props.usuario.accoprentas.toString().substring(2, 3)
                : "0",
            rent4:
              props.usuario.accoprentas.toString().substring(3, 4) !== ""
                ? props.usuario.accoprentas.toString().substring(3, 4)
                : "0",
          });

          setReportes({
            pdf1: props.usuario.accpdfrentas.toString().substring(0, 1),
          });

          setModulosConfig({
            moduloconfig1: props.usuario.accconfigrentas
              .toString()
              .substring(0, 1),
          });
        } else {
          setModulosConfig({
            moduloconfig1: "0",
          });
          setModulos({
            modulo1: "0",
            modulo2: "0",
            modulo3: "0",
          });
          setReportes({
            pdf1: "0",
          });
        }
        setTabIndex(0);
        setTabIndex1(0);
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Registrar Usuario"
              : operacion === 2
              ? "Modificar Usurario"
              : operacion === 3
              ? "Eliminar Usuario"
              : "Consultar Usuario"}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        <CatalogoPersona
          titulo={titulo}
          mensaje={msg}
          show={mostrar3}
          onHideCancelaCatPer={handleCloseCatalogoPer}
          onHideAceptaCatPer={handleAceptaCatalogoPer}
        />
        <CatalogoAgente
          titulo={titulo}
          mensaje={msg}
          show={mostrar4}
          onHideCancelaCatAge={handleCloseCatalogoAge}
          onHideAceptaCatAge={handleAceptaCatalogoAge}
        />
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div className="">
          <div>
            <ul className="nav nav-tabs mb-3" id="ex-with-icons" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link active "
                  style={{ backgroundColor: "#25d366" }}
                  id="ex-with-icons-tab-1"
                  data-mdb-toggle="tab"
                  href="#tab-1"
                  role="tab"
                  aria-controls="tab-1"
                  aria-selected="true"
                >
                  <i className="fas fa-user-edit fa-fw me-2"></i>Usuario
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link"
                  id="ex-with-icons-tab-2"
                  style={{ backgroundColor: "#55acee" }}
                  data-mdb-toggle="tab"
                  href="#tab-2"
                  role="tab"
                  aria-controls="tab-2"
                  aria-selected="false"
                >
                  <i className="fas fa-vote-yea fa-fw me-2"></i>Permisos Modulo
                  Minas
                </a>
              </li>
            </ul>
            <div className="tab-content" id="ex-with-icons-content">
              <div
                className="tab-pane fade show active"
                id="tab-1"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-1"
              >
                <div className="container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto">
                  <div className="input-group py-1 input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="far fa-lg px-1 fa-id-card"></i>Codigo:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtIdUsuario}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.usuario ? props.usuario.idusuario : ""
                      }
                      id="inputCodigo"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-file-signature"></i>Nom.
                      Usuario:
                    </label>
                    <input
                      type="text"
                      autocomplete="off"
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtLogin}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={props.usuario ? props.usuario.login : ""}
                      id="inputLogin"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-3 px-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {" "}
                      Estatus
                    </label>
                    <select
                      disabled={deshabilitado}
                      ref={cmbStatus}
                      className="form-select"
                      aria-label="Default select example"
                      defaultValue={props.usuario ? props.usuario.status : ""}
                    >
                      <option value="1">Activo</option>
                      <option value="2">Inactivo</option>
                    </select>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-unlock-alt"></i>
                      Contraseña:
                    </label>
                    <input
                      type={mostrarClave ? "text" : "password"}
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtPassword}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={operacion === 2 ? true : deshabilitado}
                      onClick={mostrarPassword}
                      className="btn btn-sm btn-info"
                    >
                      <i
                        disabled={deshabilitado}
                        className="fa fa-eye-slash"
                      ></i>{" "}
                    </button>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-unlock-alt"></i>Confir.
                      Contr.:
                    </label>
                    <input
                      type={mostrarClave1 ? "text" : "password"}
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtConfirmPassword}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputConfirmPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={operacion === 2 ? true : deshabilitado}
                      onClick={mostrarPassword1}
                      className="btn btn-sm btn-info"
                    >
                      <i
                        disabled={deshabilitado}
                        className="fa fa-eye-slash"
                      ></i>{" "}
                    </button>
                  </div>

                  <div className="col-md-12 py-1"></div>

                  <fieldset className="row border-azul rounded mx-auto">
                    <legend className="float-none m-0 w-auto">Agente</legend>

                    <div className="input-group py-1 input-group-sm col-sm-4">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="far fa-lg px-1 fa-id-card"></i>Código
                        Agente:
                      </label>
                      <input
                        type="text"
                        disabled
                        ref={txtIdAgente}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputIdAgente"
                        defaultValue={
                          props.usuario ? props.usuario.idagente : ""
                        }
                        onKeyUp={validarAgente}
                        onBlur={validarAgente}
                      />
                      <button
                        disabled={deshabilitado}
                        onClick={catalogoAge}
                        className="btn btn-sm  btn-success"
                      >
                        <i
                          disabled={deshabilitado}
                          className="fa fa-search"
                        ></i>{" "}
                      </button>
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-8">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-file-signature"></i>
                        Nombres:
                      </label>
                      <input
                        type="text"
                        disabled={true}
                        ref={txtNombreAgente}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputNomUsuario"
                        defaultValue={
                          props.usuario ? props.usuario.nombreagente.trim() : ""
                        }
                      />
                    </div>
                  </fieldset>

                  <div className="col-md-12 py-1"></div>

                  <fieldset className="row border-azul rounded mx-auto">
                    <legend className="float-none m-0 w-auto">
                      Datos Personales del Usuario
                    </legend>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="far fa-lg px-1 fa-id-card"></i>Cedula:
                        </label>
                        <input
                          type="text"
                          disabled={deshabilitado}
                          ref={txtCedula}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputCedula"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.cedula
                              : ""
                          }
                          onKeyUp={validarPersona}
                          onBlur={validarPersona}
                        />
                        <button
                          disabled={deshabilitado}
                          onClick={catalogoPer}
                          className="btn btn-sm  btn-success"
                        >
                          <i
                            disabled={deshabilitado}
                            className="fa fa-search"
                          ></i>{" "}
                        </button>
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-3 mx-auto px-2">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-map-marked-alt"></i>
                          Nacionalidad:
                        </label>
                        <select
                          disabled={!habilitadoNU}
                          ref={cmbNacionalidad}
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.nacionalidad
                              : ""
                          }
                          className="form-select"
                          aria-label="Default select example col-md-"
                        >
                          <option key="0" value="V">
                            V
                          </option>
                          <option key="1" value="E">
                            E
                          </option>
                        </select>
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-2 ml-auto px-1">
                        <label
                          className="input-group-text ml-2"
                          id="inputGroup-sizing-sm"
                        >
                          Sexo:
                        </label>
                        <select
                          disabled={!habilitadoNU}
                          ref={cmbSexo}
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.sexo
                              : ""
                          }
                          className="form-select"
                          aria-label="Default select example"
                        >
                          <option key="0" value="M">
                            M
                          </option>
                          <option key="1" value="F">
                            F
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-6 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          Nombres:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtNombreUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputNomUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.nombres.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-6 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          apellidos:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtApellidoUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputApeUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.apellidos.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-12 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          Direccion:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtDireccionUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputApeUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.direccion.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="far fa-lg px-1 fa-calendar-alt"></i>
                          Fecha Nacimiento:
                        </label>
                        <input
                          type="date"
                          disabled={!habilitadoNU}
                          ref={txtFechaNac}
                          className="form-control px-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputFechaNac"
                          max={moment(fechaSistema).format("YYYY-MM-DD")}
                          defaultValue={
                            props.datospersonales
                              ? moment(
                                  props.datospersonales.fnacimiento
                                ).format("YYYY-MM-DD")
                              : ""
                          }
                          onKeyUp={handleInputChange}
                        />
                      </div>

                      <div className="input-group py-1 input-group-sm col-sm-4">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-phone"></i>Telefono:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtTlfUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputTlfUsuario"
                          placeholder="0000-0000000"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.tlf1 !== null
                                ? props.datospersonales.tlf1.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>

                      <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-mobile-alt"></i>
                          Celular:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtCelUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputCelUsuario"
                          placeholder="0000-0000000"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.tlf2 !== null
                                ? props.datospersonales.tlf2.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-12 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          {" "}
                          <i className="fas fa-lg px-1 fa-at"></i>E-mail:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtEmailUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputEmailUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.correoe !== null
                                ? props.datospersonales.correoe.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div
                className="tab-pane fade px-2"
                id="tab-2"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-2"
              >
                <ul className="nav mb-2" id="ex-with-icons" role="tablist">
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-bold text-light rounded"
                      style={{ backgroundColor: "#25d366" }}
                      id="ex-with-icons-tab-1"
                      data-mdb-toggle="tab"
                      href="#ex-with-icons-tabs-1"
                      role="tab"
                      aria-controls="ex-with-icons-tabs-1"
                      aria-selected="true"
                    >
                      <i className="fas fa-edit mx-1" />
                      Actualizar
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-bold text-light rounded"
                      style={{ backgroundColor: "#55acee" }}
                      id="ex-with-icons-tab-2"
                      data-mdb-toggle="tab"
                      href="#ex-with-icons-tabs-2"
                      role="tab"
                      aria-controls="ex-with-icons-tabs-2"
                      aria-selected="false"
                    >
                      <i className="fas fa-cogs mx-1" />
                      Configuración
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-bold text-light rounded"
                      style={{ backgroundColor: "#F93154" }}
                      id="ex-with-icons-tab-3"
                      data-mdb-toggle="tab"
                      href="#ex-with-icons-tabs-3"
                      role="tab"
                      aria-controls="ex-with-icons-tabs-3"
                      aria-selected="false"
                    >
                      <i className="fas fa-file-pdf mx-1" />
                      Reportes
                    </a>
                  </li>
                </ul>

                <div
                  className="tab-content"
                  id="ex-with-icons-content"
                  style={{ fontFamily: "Times New Roman, Times, serif" }}
                >
                  <div
                    className="tab-pane fade show active"
                    id="ex-with-icons-tabs-1"
                    role="tabpanel"
                    aria-labelledby="ex-with-icons-tab-1"
                  >
                    <div className="py-1 row mx-auto">
                      <div className="col-md-12 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Registro de Inmuebles
                          </legend>
                          <div className="col-md-2 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo1"
                                value={"1"}
                                id="modulo"
                                checked={modulos.modulo1 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-2 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo1"
                                value={"0"}
                                id="modulo"
                                checked={modulos.modulo1 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                          {modulos.modulo1 === "1" ? (
                            <div className="col-md-8 row mb-3 rounded">
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkInmCon}
                                    onChange={check}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      acciones.inm1 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Consultar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkInmInc}
                                    onChange={check}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      acciones.inm2 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Incluir
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkInmMod}
                                    onChange={check}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      acciones.inm3 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Modificar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkInmEli}
                                    onChange={check}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      acciones.inm4 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Eliminar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkInmTodo}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      acciones.inm1 === "1" &&
                                      acciones.inm2 === "1" &&
                                      acciones.inm3 === "1" &&
                                      acciones.inm4 === "1"
                                        ? true
                                        : false
                                    }
                                    name="todoinm"
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                    onChange={onChangeTodo}
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Todo
                                  </label>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </fieldset>
                      </div>

                      <div className="col-md-12 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Registro de Rentas Inmobiliarias
                          </legend>
                          <div className="col-md-2 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo2"
                                value={"1"}
                                id="modulo"
                                checked={modulos.modulo2 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-2 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo2"
                                value={"0"}
                                id="modulo"
                                checked={modulos.modulo2 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                          {modulos.modulo2 === "1" ? (
                            <div className="col-md-8 row mb-3 rounded">
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkRentCon}
                                    onChange={check}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      acciones.rent1 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Consultar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkRentInc}
                                    onChange={check}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      acciones.rent2 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Incluir
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkRentMod}
                                    onChange={check}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      acciones.rent3 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Modificar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkRentEli}
                                    onChange={check}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      acciones.rent4 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Eliminar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkRentTodo}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      acciones.rent1 === "1" &&
                                      acciones.rent2 === "1" &&
                                      acciones.rent3 === "1" &&
                                      acciones.rent4 === "1"
                                        ? true
                                        : false
                                    }
                                    name="todorentas"
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                    onChange={onChangeTodo}
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Todo
                                  </label>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </fieldset>
                      </div>

                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Estado de Cuenta
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo3"
                                value={"1"}
                                id="modulo"
                                checked={modulos.modulo3 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo3"
                                value={"0"}
                                id="modulo"
                                checked={modulos.modulo3 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>

                      <div className="col-md-6"></div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="ex-with-icons-tabs-2"
                    role="tabpanel"
                    aria-labelledby="ex-with-icons-tab-2"
                  >
                    <div className="row mx-auto">
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Permisos Usuarios
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="moduloconfig1"
                                value={"1"}
                                id="modulosConfig"
                                checked={
                                  modulosConfig.moduloconfig1 === "1"
                                    ? true
                                    : false
                                }
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="moduloconfig1"
                                value={"0"}
                                id="modulosConfig"
                                checked={
                                  modulosConfig.moduloconfig1 === "0"
                                    ? true
                                    : false
                                }
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="ex-with-icons-tabs-3"
                    role="tabpanel"
                    aria-labelledby="ex-with-icons-tab-3"
                  >
                    <div className="row mx-auto">
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Deuda General Rentas
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf1"
                                value={"1"}
                                id="reportes"
                                checked={reportes.pdf1 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf1"
                                value={"0"}
                                id="reportes"
                                checked={reportes.pdf1 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-sm-12 d-flex justify-content-end row mx-auto py-1">
          <button
            type="button"
            ref={btnAcepta}
            disabled={operacion === 4 ? true : false}
            onClick={onChangeValidar}
            style={{ margin: "1px" }}
            className="col-sm-2 btn-sm btn btn-success rounded-pill"
          >
            <i className="far fa-check-circle"></i>Aceptar
          </button>
          <button
            type="button"
            ref={btnCancela}
            onClick={cancelar}
            style={{ margin: "1px" }}
            className="col-sm-2 btn-sm btn btn-danger rounded-pill"
          >
            <i className="fas fa-window-close"></i>Cancelar
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalActUsuarioRentas;



// WEBPACK FOOTER //
// ./src/components/permisosMdulos/modalUsuarioRentas.js